export const Players = [
  {
    id: 1,
    name: "Marchand",
    nickname: "B.Marchand",
    sport: "Football",
    league: "NHL",
    team: "Boston Bruins",
    number: 63,
    position: "C",
    nationalityFlag: "/assets/images/сanada.png",
    nationality: "England",
    headshot: "/assets/images/player.png",
    injuryStatus: "Healthy",
  },
  {
    id: 2,
    name: "Brad Marchand",
    nickname: "B.Marc",
    sport: "Hockey",
    league: "NHL",
    team: "Boston Bruins",
    number: 64,
    position: "D",
    nationalityFlag: "/assets/images/сanada.png",
    nationality: "USA",
    headshot: "/assets/images/player.png",
    injuryStatus: "Healthy",
  },
  {
    id: 3,
    name: "Brad Marchand",
    nickname: "A.Marchand",
    sport: "Hockey",
    league: "NHL",
    team: "Boston Bruins",
    number: 65,
    position: "D",
    nationalityFlag: "/assets/images/сanada.png",
    nationality: "Canada",
    headshot: "/assets/images/player.png",
    injuryStatus: "Healthy",
  },
  {
    id: 4,
    name: "Brad Marchand",
    nickname: "N.Marchand",
    sport: "Hockey",
    league: "NHL",
    team: "Boston Bruins",
    number: 66,
    position: "LW",
    nationalityFlag: "/assets/images/сanada.png",
    nationality: "Australia",
    headshot: "/assets/images/player.png",
    injuryStatus: "Healthy",
  },
];
